import React from 'react';
import { LanguageTranslator } from '../../../../../LanguageTranslator';
import { capitalizeFirstLetter } from '../../../../../helperFunctions';

const PaginateList = ({
  totalProviderListCount = 0,
  availabilityData,
  canLoadMoreVertically,
  loadMoreProviders,
  wrapperClass = 'cc-listing',
  locale = 'en',
}) => {
  const translates = (tag) => LanguageTranslator.translate(locale, tag);
  const availableRecords = availabilityData?.length || 0;
  const totalRecords =
    totalProviderListCount >= availableRecords
      ? totalProviderListCount
      : availableRecords;

  return (
    <div
      className={`d-flex flex-row gap-2-rem justify-content-center padding-top-lgx call_center_lazy_load ${wrapperClass}`}
    >
      {totalRecords && (
        <div className="italic color-gray-0 font-weight-300">
          {capitalizeFirstLetter(translates('showing'))}{' '}
          <span id="current-count">{availableRecords}</span> {translates('of')}{' '}
          <span id="total-count"> {totalRecords} </span>{' '}
          {translates('providers')}
        </div>
      )}
      {canLoadMoreVertically && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
        <a
          id="see-more-providers-link"
          className="see-more-providers-link cursor-pointer text-decoration-underline plum-font"
          onClick={loadMoreProviders}
        >
          {translates('see_more_providers')}
        </a>
      )}
    </div>
  );
};

export default PaginateList;
